module.exports = __webpack_public_path__ + "static/media/weddinggift.561236c3.png";